import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
    public message: string;
    public checkoutId: string;
    public showButton = false;

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        switch (this.route.snapshot.params.status) {
            case 'get-checkout':
                this.message = 'Hubo problemas al traer información de tu compra.';
                this.showButton = true;
                break;
            default:
                this.message = 'Esta página no se pudo encontrar. Error (404)';
                break;
        }
    }

    public navigateToShipment(): void {
        const { queryParams } = this.route.snapshot;
        this.router.navigateByUrl('shipment-info');
        this.router.navigate(['shipment-info'], { queryParams });
    }

}
